import React from 'react';
import { Checkbox } from '@mui/material';
import CheckedXIcon from './CheckedXIcon';
import SkeletonWrapper from './skeleton/SkeletonWrapper';

/**
 * @typedef {object} CheckboxFieldProps
 * @property {string} [title]
 * @property {string} [name]
 * @property {boolean} [checked]
 * @property {(name: string, checked: boolean) => void} [handleChange]
 * @property {string} [testId]
 * @property {boolean} [loading]
 * @property {boolean} [disabled]
 */

/**
 * @param {CheckboxFieldProps} props
 */
const CheckboxField = props => {
  const {
    title = '',
    name = '',
    checked,
    testId = '',
    handleChange,
    loading = false,
    disabled = false
  } = props;

  return (
    <div className='checkbox-wrapper'>
      <SkeletonWrapper show={loading}>
        <Checkbox
          name={name}
          checked={checked || false}
          data-testid={testId}
          size='small'
          checkedIcon={<CheckedXIcon size='small' />}
          onChange={e => handleChange(name, e.target.checked)}
          color='default'
          disabled={disabled}
        />
      </SkeletonWrapper>
      <span className='margin-title'>{title}</span>
    </div>
  );
};

export default CheckboxField;
